// extracted by mini-css-extract-plugin
export default {"errorMessage":"mapa_errorMessage__XxMNr","inputFooter":"mapa_inputFooter__ZtLmQ"};